exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn.green{color:#fff;background-color:#627d4c;border-color:#aeafb1}.btn.green.active,.btn.green:active,.btn.green:focus,.btn.green:hover{color:#fff;background-color:#759c55;border-color:#759c55}.btn.red{color:#fff;background-color:#f71414}.btn.red.active,.btn.red:active,.btn.red:focus,.btn.red:hover{color:#fff;background-color:#fa7272;border-color:#fa7272}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b4d2cab","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/button.vue
// module id = 1125
// module chunks = 0